// Espelho da lista de permissão do backend (`backend/src/config/upload.ts`,
// constante `allowedExtensions`). O backend é a autoridade: ele recusa o que
// não estiver na lista dele, e esta cópia existe só para o navegador avisar
// ANTES de subir o arquivo inteiro — quem anexa um .exe de 20 MB não deveria
// esperar o upload terminar para descobrir que não vale.
//
// Ao mexer na lista de lá, mexa aqui também.
export const EXTENSOES_ACEITAS = [
	// imagem — sem .svg, que é XML com script dentro
	".jpg",
	".jpeg",
	// .jfif é JPEG com outro nome: alguns programas salvam assim e o arquivo
	// chegava recusado mesmo sendo a mesma foto.
	".jfif",
	".png",
	".gif",
	".webp",
	".bmp",
	".tiff",
	".heic",
	".heif",
	// áudio
	".mp3",
	".ogg",
	".oga",
	".opus",
	".wav",
	".m4a",
	".aac",
	".amr",
	".flac",
	// vídeo
	".mp4",
	".3gp",
	".mov",
	".avi",
	".mkv",
	".webm",
	// documentos
	".pdf",
	".doc",
	".docx",
	".xls",
	".xlsx",
	".ppt",
	".pptx",
	".odt",
	".ods",
	".odp",
	".rtf",
	".txt",
	".csv",
	".md",
	".json",
	".xml",
	".epub",
	// compactados
	".zip",
	".rar",
	".7z",
	".gz",
	".tgz"
];

// Valor do atributo `accept` do <input type="file">. Filtra o que aparece na
// janela do sistema; não substitui a validação, que qualquer um contorna
// escolhendo "todos os arquivos".
export const ACCEPT_UPLOAD = EXTENSOES_ACEITAS.join(",");

// Apenas imagens: usado para avatares, capa de campanha, logo — locais onde
// um PDF ou vídeo nunca fazem sentido. Reflete o subconjunto de extensões
// de imagem que o backend também exige para rotas específicas de upload.
export const EXTENSOES_IMAGENS = [
	".jpg",
	".jpeg",
	".jfif",
	".png",
	".gif",
	".webp",
	".bmp",
	".tiff",
	".heic",
	".heif"
];
export const ACCEPT_ONLY_IMAGES = EXTENSOES_IMAGENS.join(",");

export const TAMANHO_MAXIMO_MB = 120;
export const TAMANHO_MAXIMO_BYTES = TAMANHO_MAXIMO_MB * 1024 * 1024;

// Quanto o navegador espera pela resposta do envio de mídia.
//
// O timeout padrão do axios (120 s, em services/api.js) serve para requisição
// comum, mas o POST de anexo só responde no FIM de todo o trabalho: multer
// grava o arquivo, o ffmpeg converte e o backend repassa para o WhatsApp —
// tudo dentro da mesma requisição. Numa conexão de subida lenta (~100 KB/s,
// comum em 4G e em link residencial) um vídeo de 15 MB já consome mais de
// dois minutos; o navegador desistia em 120 s e a tela mostrava só o
// "An error occurred!" genérico, embora o arquivo continuasse subindo.
//
// O nginx do servidor aceita 300 s (proxy_read_timeout/proxy_send_timeout, no
// instalador), então este teto acompanha o dele em vez de cortar antes.
export const TIMEOUT_ENVIO_MEDIA_MS = 300000;

// A partir deste tamanho o anexo sobe em PARTES, e não num POST único.
//
// O proxy da frente (Cloudflare) responde 524 — e nenhuma resposta chega ao
// navegador — quando a origem demora mais de 100 s. Como o POST de anexo só
// responde no FIM de tudo (gravar + converter + entregar), um vídeo de 15 MB
// num link de subida lento estourava esse corte e a tela mostrava só o erro
// genérico. Abaixo do limite o envio direto continua valendo: é uma
// requisição só, mais simples.
export const LIMITE_ENVIO_EM_PARTES_BYTES = 2 * 1024 * 1024;

// Tamanho de cada parte. Com 1 MB, mesmo a 30 KB/s a parte termina em ~35 s,
// com folga para o corte de 100 s do proxy.
export const TAMANHO_PARTE_BYTES = 1024 * 1024;

// Cada parte é curta de propósito: se uma travar, é melhor avisar antes de o
// proxy cortar do que esperar os 300 s do envio direto.
export const TIMEOUT_PARTE_MS = 90000;

export const extensaoDoArquivo = (nome = "") => {
	const ponto = nome.lastIndexOf(".");
	return ponto === -1 ? "" : nome.slice(ponto).toLowerCase();
};

// Devolve a mensagem do problema, ou "" quando o arquivo passa. Mensagem, e
// não booleano, porque quem recusa precisa dizer o motivo.
export const problemaDoArquivo = (arquivo) => {
	const ext = extensaoDoArquivo(arquivo?.name);

	if (!EXTENSOES_ACEITAS.includes(ext)) {
		return ext
			? `arquivos ${ext} não são aceitos`
			: "arquivos sem extensão não são aceitos";
	}

	if (arquivo.size > TAMANHO_MAXIMO_BYTES) {
		const mb = (arquivo.size / 1024 / 1024).toFixed(1);
		return `tem ${mb} MB e o limite é ${TAMANHO_MAXIMO_MB} MB`;
	}

	return "";
};
